import { Component, OnInit, ViewChild, TemplateRef, Input } from '@angular/core';
import { DataTablesResponse } from '../../shared/models/datatables-response';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { HttpClient } from '@angular/common/http';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { environment } from '../../../environments/environment';
import { AuthenticationService } from '../../shared/auth/authentication.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { PropertyStatus } from '../../shared/enum/enum';
import { UserManagerService } from '../../shared/providers/user-manager.service';
import { IBrokerageList } from '../../shared/models/BrokerageListOutputModel';
import { IDataEntryStaffPropertyOutputList } from '../../shared/models/DataEntryStaffPropertyListOutputModel';
import { BrokerageManagerService } from '../../shared/providers/brokerage-manager.service';
import { ValidationService } from '../../shared/providers/validation.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToastService } from '../../shared/providers/toast.service';
import { PropertyListingService } from '../../shared/providers/property-listing.service';
import { LoaderService } from '../../shared/providers/loader.service';
import { ILookUp } from '../../shared/models/LookUpOutputModel';
import { CommonService } from '../../shared/providers/common.service';
import { IPropertyCard, PropertyIdList } from '../../shared/models/propertycard';
import { RestService } from '../../shared/providers/rest.service';
import { IUpdateTimestampModel } from '../../shared/models/IUpdateTimestampModel';
import { IPropertySearchCriteria } from '../../shared/models/propertysearchcriteria';
import { Subject, Subscription } from 'rxjs';
import { ComparePropertiesModel } from '../../shared/models/ComparePropertiesModel';
import { ComparisonService } from '../../shared/providers/comparison.service';
import { ComparePropertyDetailModel } from '../../shared/models/ComparePropertyDetailModel';
import { MaxValuesComparisonModel } from '../../shared/models/MaxValuesComparisonModel';
import { ComparePropertyDataTotalOrAvgModel } from '../../shared/models/ComparePropertyDataTotalOrAvgModel';
import { PortfolioAnalysisInputModel } from '../../shared/models/PortfolioAnalysisInputModel';
import { SharedService } from '../../shared/providers/shared.service';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

import html2canvas from 'html2canvas';
import * as Highcharts from 'highcharts';
import { MyPortfolioSummaryComponent } from '../MarketSnapshot/My-Portfolio-Summary/my-portfolio-summary.component';
import { OnDestroy } from '@angular/core';
declare var require: any;

export enum Actions {
  NothingSelected = 0,
  ChangeStatus = 1,
  MarkAsComp = 2,
  MarkAsArchive = 3,
  AssignBroker = 4,
  Delete = 5,
  MoveToLiveListing = 6,
  Verify = 7
}
export enum CompOrArhive {
  Comp = 1,
  Archive = 2,
  LiveListing = 6,
  Verify = 7
}
interface IPortfolioData {
  Name: string;
  Id: number;
  UserGuid: string;
}
interface IEditRequest {
  PropertyGuid: string;
  LoggedInUserId: number;
  PrincipalUserGuid: string;
  Comments: string;
  UserGuid: string;
}
if (typeof Highcharts === 'object') {
  let Boost = require('highcharts/modules/boost');
  let noData = require('highcharts/modules/no-data-to-display');
  let More = require('highcharts/highcharts-more');

  Boost(Highcharts);
  noData(Highcharts);
  More(Highcharts);
  noData(Highcharts);
}
@Component({
  selector: 'app-property-listing',
  templateUrl: './property-listing.component.html',
  styleUrls: ['./property-listing.component.css']
})
export class PortfloioPropertyListingComponent implements OnInit,OnDestroy {

  constructor(private propertyService: PropertyListingService, private _toastService: ToastService,
    private modalService: BsModalService, private _brokerageManagerService: BrokerageManagerService,
    public Validation: ValidationService, private router: Router, public authService: AuthenticationService,
    private http: HttpClient, private _userManagerService: UserManagerService, protected _propertyListingService: PropertyListingService,
    protected loaderService: LoaderService, private _sharedService: SharedService, private Common: CommonService, private rest: RestService, private activatedRoute: ActivatedRoute, private _comparisonService: ComparisonService) { }
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  @ViewChild(MyPortfolioSummaryComponent) child !: any;
  table: DataTableDirective;
  dtOptions = {};
  user: any;
  available: number = 0;
  IsValid = true;
  rejected: number = 0;
  pending: number = 0;
  draft: number = 0;
  fromPage: string = this.router.url;
  viewSoldDetailsLink = false;
  isDataEntryProperty: boolean = true;
  propertyList: IDataEntryStaffPropertyOutputList[];
  selectedRows: IDataEntryStaffPropertyOutputList[] = [];
  propertyCompleteList = [];
  propertyStatus = PropertyStatus;
  modalOffMarket: BsModalRef;
  propertyStatusId: number = 0;
  brokerageList: IBrokerageList[];
  brokerageId: number = 0;
  totalCount: number = 0;
  totalCountBrokerage: number = 0;
  isviewAll: boolean = true;
  isAvailable: boolean = false;
  searchCriteria: IPropertySearchCriteria;
  isPending: boolean = false;
  isRejected: boolean = false;
  isDraft: boolean = false;
  selectedPropertyId: string;
  selectedPendingProperty = {} as any;
  selectedPendindId: string = '';
  searchText: string = "";
  quickEditDetails = [];
  protected readonly BASE_URL: string = environment.base_url;
  selectedAction = 0;
  propertyIdList: PropertyIdList[];
  EditRequest = {} as IEditRequest;
  principalUserGuid: string = '';
  IsStandardUser = false;
  UserPortfolio: IPortfolioData[] = [];
  portfolioData = "'s Properties";
  selectedPortfolio: number = 0;
  currentGuid: string = '0000';
  selectedPortfolioName: string = 'My Properties'
  linkname: string;
  IsmyPortfolio = true;
  @Input() isShowAnalyze: boolean;
  comparePropertiesModel = {} as ComparePropertiesModel;
  pendingProperties = [] as any;
  propertyIds: number[];
  dtTrigger = new Subject();
  @Input() isPropertyAnalysis: boolean;
  @Input() isFromViewPage: boolean;
  comparePropertyDetailModelList: ComparePropertyDetailModel[];
  comparePropertyDetailCheckedModelList: ComparePropertyDetailModel[];
  analyzePropertyDetailModelList: ComparePropertyDetailModel[];
  comparePropertyDataTotalOrAvgModel = {} as ComparePropertyDataTotalOrAvgModel;
  isAnalyze: boolean = false;
  priceTotal: number;
  year: Date = new Date();
  currentYear: number;
  expirationYear: number;
  leaseExpirationYear: number;
  addPropertyList: IDataEntryStaffPropertyOutputList[];
  comparePropertiesLength: number;
  maxCompareValues: MaxValuesComparisonModel;
  isAnalyzeName: boolean = false;
  enableExtendedChart: boolean = false;
  showAnalysisTab: boolean = false;
  analyzeId: number = 0;
  isSaveDisabled: boolean = false;
  subscriptions: Subscription[] = [];
  @Input() UserGuid: string;
  IsLoading = false;
  prevPageRouteLink = "market-snapshot";
  disableAdd = false;
  showNodata: boolean;
  disableAddButton = false;
  isFromOfferPortfolio = false;
  uncheckedData: ComparePropertyDetailModel;
  onSearch(text: string) {
    this.dtElement.dtInstance.then(x => x.search(text).draw());
  }

  updateTimestamp = {} as IUpdateTimestampModel;
  
  viewAll = '';
  propertyStatusList: ILookUp[];
  ngOnInit() {
    
    if (localStorage.getItem('principalGuid') != null && localStorage.getItem('principalGuid') != undefined) {
      this.principalUserGuid = localStorage.getItem('principalGuid');
      localStorage.removeItem('principalGuid');
    }
    this.user = this.authService.user;
    var loggedinUserId = this.user.Id;
    this.UserGuid = this.UserGuid != '' && this.UserGuid != undefined && this.UserGuid != null ? this.UserGuid : '0000';
    this.bindData();
    if (this.isShowAnalyze) {
      this.LoadPortfolioAnalysisDetail();
    }
    /*  this.getOtherUserPortfolio();*/

    const that = this;
    this.user = this.authService.user;
    this.resetSelectedRows();
    var loggedinUserId = this.user.Id;
       
    if (localStorage.getItem("SearchText") != "null") {
      //that.searchText = localStorage.getItem("SearchText");
    }
    else {
      that.searchText = null;
    }
   
    //this._userManagerService.getBrokerages(loggedinUserId).subscribe(response => {
    //  this.brokerageList = response.map(o => { return { Id: o.Id, BrokerageName: o.BrokerageName }; });
    //});
    this.reassignSelectedRows();

    this.subscriptions.push( this._propertyListingService.getAllPrincipalPortfolioProperty(this.user.Id, this.UserGuid).subscribe(response => {
      if (response) {
        this.addPropertyList = response ? response : [];
      }
    }));

    this.dtOptions = {
      pagingType: 'full_numbers',
      serverSide: true,
      processing: true,
      "pageLength": 20,
      //stateSave: true,
      //stateSaveCallback: function (settings, data) {
      //  localStorage.setItem("DataTables_property_dataEntryStaff_list_view", JSON.stringify(data));
      //},
      //stateLoadCallback: function (settings) {
      //  $(".dataTables_paginate.paging_full_numbers").show();
      //  return JSON.parse(localStorage.getItem("DataTables_property_dataEntryStaff_list_view"));
      //},
      "order": [[9, "desc"]],
      info: false,
      language: {
        zeroRecords: null,
        processing: `<div class="custom-dt-loader">
        <div class="circle-loader-wrapper">
          <div class="circle-loader-ring"></div>
          <img src="assets/img/logos/logo.png" class="loader-icon" />
        </div>
      </div>
     `,
      },
      bLengthChange: false,
      initComplete: () => $('.dataTables_filter').css('display', 'none'),
      ajax: (dataTablesParameters: any, callback: Function) => {
        this.IsLoading = true;

        const filter =
        {
          //// StatusId: that.propertyStatusId,
          BrokerageId: that.brokerageId,
          PropertyTypeId: 6857,
          UserId: this.user.Id,
          IsPortfolio: true,
          UserGuid: that.UserGuid
        }

        dataTablesParameters.Extra_param = filter;
        //that.searchText = dataTablesParameters.search.value;
        const httpHeader = this.rest.GetAuthHeader();

        this.subscriptions.push(that.http
          .post<DataTablesResponse>(
            this.BASE_URL + '/property/myPortfolioPropertyList/' + loggedinUserId + '/' + this.UserGuid,
            dataTablesParameters, httpHeader
          ).subscribe(resp => {
            that.propertyList = resp.data ? resp.data : [];
            if (resp.data.length > 0) {
              that.propertyList.forEach(item => {
                if (item.WebsiteURL != null) {
                  item.WebsiteURL = this.Validation.formatURL(item.WebsiteURL);
                }
                //item.DDFileCount = item.Documents.filter(x => x.CategoryId != 401).length;
                //item.OMFileCount = item.Documents.filter(x => x.CategoryId == 401).length;

                item.RemainingTerm = this.Validation.remainingTermForCardandTables(item.LeaseExpiration, item.CurrentDate);

                if (this.selectedRows.findIndex(x => x.Id == item.Id && x.Type == item.Type) > -1) {
                  item.IsSelected = true;
                }
                if (item.CharacteristicsId == 1) {
                  item.capRateText = 'ZCF';
                }
                else {
                  item.capRateText = String(item.CapRate);
                }
              });
              this.comparePropertiesModel.PropertyList = this.propertyList;
              this._comparisonService.comparePropertiesModelData = this.comparePropertiesModel;
              this.autoSelectAll();
              that.totalCount = resp.data.length;

            }
            if (resp.data.length === 0) {
              $(".dataTables_paginate.paging_full_numbers").hide();
            }
            if (resp) {
              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: []
              });
              if (resp.data.length === 0) {
                $(".dataTables_paginate.paging_full_numbers").hide();
              }
              else {
                $(".dataTables_paginate.paging_full_numbers").show();
              }
              $(".paginate_button.first,.paginate_button.last").hide();
            } else {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
            }
            this.IsLoading = false;;
            $(".paginate_button.first,.paginate_button.last").hide();
          }));
      },
      columns: [
        { data: 'Guid' },
        { data: 'Guid' },
        { data: 'Guid' },
        { data: 'PropertySequenceId' },
        { data: 'PropertyName' },
        { data: 'StateName' },
        { data: 'CityName' },
        { data: 'PropertyStatus' },
        { data: 'LeaseType' },
        { data: 'NOI' },
        { data: 'RemainingTerm' }]
    };
  }

  AuditId: number;
  modalRef: BsModalRef;

  //GetPropertyCount() {
  //  var loggedinUserId = this.user.Id;

  //  this.propertyService.GetPropertiesOfDataEntryStaffCount(this.brokerageId, loggedinUserId).subscribe(response => {
  //    if (response != null) {
  //      this.available = response[0].AvailableCount;
  //      this.rejected = response[0].RejectedCount;
  //      this.pending = response[0].PendingCount;
  //      this.draft = response[0].DraftCount;
  //      this.totalCountBrokerage = response[0].TotalCount;
  //    }
  //  });
  //}
  openModalForAuditTrailDetail(template: TemplateRef<any>, classes: any, id) {
    this.AuditId = id;;
    this.modalRef = this.modalService.show(template, { class: classes });
  }

  getAnalyzeMethod(): any {
    return {
     analyzeProperties: () => {
        this.Analyze();
      }
    }
  }

  openModalForQuickEdit(template: TemplateRef<any>, classes: any, id, state, city, brokerage, type) {
    this.quickEditDetails = [];
    if (type == 2) {
      this.isDataEntryProperty = false;
    }
    else {
      this.isDataEntryProperty = true;
    }
    this.modalRef = this.modalService.show(template, { class: classes });
    this.selectedPropertyId = id;
    this.quickEditDetails.push(state, city, brokerage);
  }
   
  //filterByStatus(statusid, event) {
  //  this.propertyStatusId = statusid;
  //  this.SelectByStatus(this.propertyStatusId);
  //  localStorage.setItem("statusId", this.propertyStatusId.toString());
  //  localStorage.setItem("available", this.available.toString());
  //  localStorage.setItem("pending", this.pending.toString());
  //  localStorage.setItem("rejected", this.rejected.toString());
  //  localStorage.setItem("draft", this.rejected.toString());
  //  //this.resetSelectedRows();
  //  this.selectAll = false;
  //  this.onStatusSelect(event);
  //}
  //onStatusSelect($event) {

  //  if (this.propertyStatusId != undefined) {
  //    this.dtElement.dtInstance.then(x => x.draw());
  //    this.GetPropertyCount();
  //  }
  //}
  closeModal($event) {
    if (this.modalRef != undefined) {
      this.modalRef.hide();
    }
    this.dtElement.dtInstance.then(x => x.draw());
  }

  downloadAllDoc(Documents, type, event: any) {
    if (type == 1) {
      for (let document of Documents.filter(x => x.CategoryId == 401)) {
        window.open(document.FilePath, '_blank');
      }
    }
    else {
      for (let document of Documents.filter(x => x.CategoryId != 401)) {
        window.open(document.FilePath, '_blank');
      }
    }

  }
  statusToChange = 0;
  showSelectStatus = false;
  ConfirmationHeading = '';
  confirmBody = '';
  selectAll = false;
  
  getSelectedCount() {
    return this.selectedRows.length;
  }
  onCheckboxChange(event, Id, Type) {
    if (event) {
      let prop = this.propertyList.find(x => x.Id == Id && x.Type == Type);
      this.selectedRows.push(prop);
    }
    else {
      this.selectedRows.splice(this.selectedRows.findIndex(x => x.Id == Id && x.Type == Type), 1);
    }
    this.preserveSelectedRows();
    this.autoSelectAll();
  }

  autoSelectAll() {
    if (this.propertyList.filter(x => x.IsSelected == true).length == this.propertyList.length && this.propertyList.length > 0) {
      this.selectAll = true;
    }
    else {
      this.selectAll = false;
    }
  }
  onSelectAll(event) {
    if (event.target.checked) {
      this.selectOrUnSelectAll(true);
    }
    else {
      this.selectOrUnSelectAll(false);
    }
  }
  selectOrUnSelectAll(trueOrfalse) {
    this.propertyList.forEach(item => {
      item.IsSelected = trueOrfalse;
      if (trueOrfalse) {
        // if true then push all selected items into selectedRows collection
        if (this.selectedRows.findIndex(x => x.Id == item.Id && x.Type == item.Type) < 0) {
          this.selectedRows.push(item);
        }
      }
      else {
        // if false then current item from the selected row collection
        this.selectedRows.splice(this.selectedRows.findIndex(x => x.Id == item.Id && x.Type == item.Type), 1);
      }
    });
    this.preserveSelectedRows();
    if (!trueOrfalse) {
      this.selectAll = false;
    }

  }

  preserveSelectedRows() {
    localStorage.setItem("des_myproperties_selectedRows", JSON.stringify(this.selectedRows));
  }

  //// modalRef: BsModalRef;
  IsPortfolio = false as boolean;
  modalRefShareListing: BsModalRef;
  propertyToDelete: string;
  property: string;
  deleteIndex: number;
  openModal(template: TemplateRef<any>, classes: any, propertyToDelete: string, propertyName: string, index: number) {
    this.propertyToDelete = propertyToDelete;
    this.property = propertyName;
    this.deleteIndex = index;
    //// this.IsPortfolio = this.propertyList[index].IsPortfolio;
    this.modalRef = this.modalService.show(template, { class: classes });
  }

  deleteProperty() {
    let text = "Property";
    var loggedinUserId = this.user.Id;
    this.subscriptions.push(this._propertyListingService.deleteDataEntryProperty(this.propertyToDelete, loggedinUserId).subscribe(response => {
      if (response) {
        this.propertyList.splice(this.deleteIndex, 1);
        let propertyIndexToDelete = this.selectedRows.findIndex(x => x.Guid == this.propertyToDelete);
        if (propertyIndexToDelete > -1) {
          this.selectedRows.splice(propertyIndexToDelete, 1);
          this.preserveSelectedRows();
        }
        //// this.propertyCount = this.propertyCount - 1;
        this._toastService.addToast({ title: 'Success', msg: text + ' deleted successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
      }
      else {
        this._toastService.addToast({ title: 'Error Occurred', msg: 'Failed to delete ' + text, timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      }
    }));
  }

  reassignSelectedRows() {
    if (this.selectedRows.length == 0 && localStorage.getItem("des_myproperties_selectedRows") !== null) {
      this.selectedRows = JSON.parse(localStorage.getItem("des_myproperties_selectedRows"));
    }
  }

  resetSelectedRows() {
    this.selectedRows = [];
    if (this.propertyList) {
      this.propertyList.forEach(item => {
        item.IsSelected = false;
      });
    }
    this.selectAll = false;
    this.preserveSelectedRows();
  }
  modalRefDuplicates: BsModalRef;
  selectedPropertyIdForDuplicates = 0;
  openModalForDuplicates(template: TemplateRef<any>, classes: any, id) {
    this.selectedPropertyIdForDuplicates = id;
    this.modalRefDuplicates = this.modalService.show(template, { class: classes });
  }

  showPortfolioProperties(id, index) {
    if (this.propertyList[index].PortfolioProperties == undefined || this.propertyList[index].PortfolioProperties.length == 0) {
      this.loaderService.display(true);
      this.subscriptions.push(this._propertyListingService.GetPortfolioPropertyListForMyPortfolio(id, this.user.Id).subscribe(item => {
        this.propertyList[index].PortfolioProperties = item["data"];
        this.propertyList[index].PortfolioProperties.forEach(p => {
          if (p.CharacteristicsId == 1) {
            p.capRateText = 'ZCF';
          }
          else {
            p.capRateText = String(p.CapRate);
          }

          p.RemainingTerm = this.Validation.remainingTermForCardandTables(p.LeaseExpiration, p.CurrentDate);
        });

        this.propertyList[index].ShowPortfolioProperties = true;
        this.loaderService.display(false);
      }));
    }
    else {
      this.propertyList[index].ShowPortfolioProperties = !this.propertyList[index].ShowPortfolioProperties;
    }
  }

  propertyToEdit: string;
  propertyNameToEdit: string;
  requestedComment = '';
  requestedDate: Date;
  requestDetail;
  openModalForEditApprove(template: TemplateRef<any>, classes: any, propertyToEdit: string, propertyName: string) {
    this.propertyToEdit = propertyToEdit;
    this.propertyNameToEdit = propertyName;
    this.requestDetail = undefined;
    this.subscriptions.push(this._propertyListingService.getrequestdetail(this.propertyToEdit, this.UserGuid).subscribe(response => {
      if (response != null) {
        this.requestDetail = response;
        this.requestedComment = this.requestDetail.LatestRequest;
        this.requestedDate = this.Validation.convertUTCDateToLocalDate(this.requestDetail.RequestedDate);
      }
      this.modalRef = this.modalService.show(template, { class: classes });
    }));
  }

  Comments = "";
  EditLiveProperty() {
    this.loaderService.display(true);
    var loggedinUserId = this.user.Id;
    var principalGuid = '0000';

    if (this.principalUserGuid != null && this.principalUserGuid != '') {
      var principalGuid = this.principalUserGuid;
    }

    this.EditRequest.PropertyGuid = this.propertyToEdit;
    this.EditRequest.LoggedInUserId = loggedinUserId;
    this.EditRequest.PrincipalUserGuid = principalGuid;
    this.EditRequest.Comments = this.Comments;
    this.EditRequest.UserGuid = this.UserGuid;

    this.subscriptions.push(this._propertyListingService.requesteditproperty(this.EditRequest).subscribe(response => {
      if (response) {
        this.Comments = "";
        this.loaderService.display(false);
        this.modalRef.hide();
        this._toastService.addToast({ title: 'Success', msg: ' Request submitted successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
      }
      else {
        this.loaderService.display(false);
        this.modalRef.hide();
        this._toastService.addToast({ title: 'Error Occurred', msg: 'Failed to submit request ', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      }
    }));
  }

  showPortfolioPropertieslive(id, index) {
    if (this.propertyList[index].PortfolioProperties == undefined || this.propertyList[index].PortfolioProperties.length == 0) {
      this.loaderService.display(true);
      let ids: number = id;
      this.subscriptions.push(this._propertyListingService.GetPrincipalPortfolioList(ids).subscribe(item => {
        if (item != null && item.length > 0) {
          this.propertyList[index].PortfolioProperties = item;
          this.propertyList[index].PortfolioProperties.forEach(p => {
            if (p.CharacteristicsId == 1) {
              p.capRateText = 'ZCF';
            }
            else {
              p.capRateText = String(p.CapRate);
            }
          });

          this.propertyList[index].ShowPortfolioProperties = true;
          this.loaderService.display(false);
        }
        else {
          this.loaderService.display(false);
        }
      }))
    }
    else {
      this.propertyList[index].ShowPortfolioProperties = !this.propertyList[index].ShowPortfolioProperties;
    }
  }
  //getOtherUserPortfolio() {
  //  let userIds = '0000';
  //  this._propertyListingService.GetOtherUserPortfolio(this.user.Id, this.currentGuid).subscribe(response => {
  //    this.UserPortfolio = response;
  //    if (this.principalUserGuid != null && this.principalUserGuid != '' && this.principalUserGuid != '0000') {
  //      let currentPortfolio = this.UserPortfolio.find(x => x.UserGuid == this.principalUserGuid);
  //      if (currentPortfolio != null) {
  //        this.selectedPortfolio = currentPortfolio.Id;
  //        this.selectedPortfolioName = currentPortfolio.Name;
  //        this.IsmyPortfolio = (this.selectedPortfolio == this.user.Id) ? true : false;
  //        this.linkname = (this.selectedPortfolio == this.user.Id) ? 'My Properties' : (this.selectedPortfolioName + "'s Properties");
  //      }
  //    }
  //    else {
  //      let currentPortfolio = this.UserPortfolio.find(x => x.Id == this.user.Id);
  //      if (currentPortfolio != null) {
  //        this.principalUserGuid = currentPortfolio.UserGuid;
  //        this.selectedPortfolio = currentPortfolio.Id;
  //        this.selectedPortfolioName = currentPortfolio.Name;
  //        this.IsmyPortfolio = (this.selectedPortfolio == this.user.Id) ? true : false;
  //        this.linkname = (this.selectedPortfolio == this.user.Id) ? 'My Properties' : (this.selectedPortfolioName + "'s Properties");
  //      }
  //    }
  //    this.dtElement.dtInstance.then(x => x.draw());
  //  });
  //}


  openAddNewProperty() {
    /* this.router.navigate(['/portfolio-property'], { queryParams: { UserGuid: this.UserGuid, IsmyPortfolio: this.IsmyPortfolio, SelectedPortfolioName: this.selectedPortfolioName } });*/

    this.router.navigate(['/portfolio-principal-property'], { queryParams: { UserGuid: this.UserGuid, IsmyPortfolio: this.IsmyPortfolio, SelectedPortfolioName: this.selectedPortfolioName } });
  }

  bindData() {
    if (this.UserGuid != null) {
      this.IsmyPortfolio = (this.UserGuid == this.user.Guid) ? true : false;
      this.selectedPortfolioName = "My Properties";
      this.linkname = this.selectedPortfolioName;
    }
  }

  analyze(fromHtml = false) {

    if (this.analyzePropertyDetailModelList.length > 1) {
      if (this.isSaveDisabled) {
        this.isSaveDisabled = false;
      }

      this.showNodata = false;
      this.isAnalyze = true;
      this.comparePropertiesLength = this.comparePropertiesModel.PropertyIds.length;
      this.getColumnTotalOrAvg(true);
      //this.bindPriceChart();
      this.bindNOIChart();
      if (this.isPropertyAnalysis) {
        this.bindCapRateChartForPrpertyAnalysis();
      } else {
        this.bindCapRateChart();
      }


      //this.bindLandAreaChart();
      setTimeout(() => {
        this.bindRemainingTermChart();
        this.bindLandAreaChart();

      }, 10);
      setTimeout(() => {
        this.bindCreditRatingChart();
      }, 10);
      setTimeout(() => {
        this.bindRevenueChart();
      }, 10);
      this.bindReturnDuringLeaseChart();
      var element = document.getElementById("divAnalytics");

      if (!this.isFromViewPage) {
        this.scrollToBottom(element, 790);
      }

    }
    else {
      if (fromHtml) {
        this._toastService.addToast({ title: 'Error Occurred', msg: 'Please select at least 2 properties', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      }
      else {
        this.showNodata = true;
      }
    }
  }

  LoadPortfolioAnalysisDetail() {

    this.loaderService.display(true);
    this.analyzeId = 0;
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      let routeLink = params['link'];
      if (routeLink !== null && routeLink !== undefined) {
        this.prevPageRouteLink = routeLink;
      }
      if (params['id'] !== undefined && params['id'] !== null && params['id'] !== '' && params['id'] !== 'NaN') {
        this.analyzeId = Number(params['id']);
      }
    });

    this.user = this.authService.user;
    this.currentYear = this.year.getFullYear();
    this.isShowAnalyze = true;

    if (this.analyzeId != undefined && this.analyzeId != 0 && !Number.isNaN(this.analyzeId)) {
      this.subscriptions.push(this._comparisonService.getPortfolioAnalyzeDetail(this.analyzeId).subscribe(response => {
        this.comparePropertiesModel = response;
        this.comparePropertiesLength = this.comparePropertiesModel.PropertyIds.length;
        this.analyzePropertyDetailModelList = [];
        this.comparePropertiesModel.PropertyList = this._comparisonService.comparePropertiesModelData.PropertyList;
        this.loadComparePropertyData(false);
        this.comparePropertiesModel.UserId = this.user.Id;
        this.isPropertyAnalysis = this.comparePropertiesModel.IsPropertyAnalysis;
      }));
    }
    else {
      this.analyzeId = 0;
      this.comparePropertiesModel = this._comparisonService.comparePropertiesModelData;

      this.comparePropertiesLength = this.comparePropertiesModel.PropertyIds.length;
      this.analyzePropertyDetailModelList = [];
      this.loadComparePropertyData(false);
      this.comparePropertiesModel.UserId = this.user.Id;
      this.comparePropertiesModel.IsPropertyAnalysis = this.isPropertyAnalysis;

    }
  }

  loadComparePropertyData(isFromNgOnInit) {
    if (this.comparePropertiesModel.Exchange1031Id != undefined) {

      let portfolioAnalysisInputModel = {} as PortfolioAnalysisInputModel;
      portfolioAnalysisInputModel.Name = this.comparePropertiesModel.Name;
      portfolioAnalysisInputModel.UserId = this.comparePropertiesModel.UserId;
      portfolioAnalysisInputModel.PropertyIds = [];
      portfolioAnalysisInputModel.DataEntryPropertyIds = [];
      this.comparePropertiesModel.PropertyIds.forEach(item => {
        if (this.comparePropertiesModel.PropertyList.find(p => p.Id == item && p.IsCreated == 0) != undefined) {
          portfolioAnalysisInputModel.PropertyIds.push(item);
        }
        else if (this.comparePropertiesModel.PropertyList.find(p => p.Id == item && p.IsCreated == 1) != undefined) {
          portfolioAnalysisInputModel.DataEntryPropertyIds.push(item);
        }
      });

      this.subscriptions.push(this._comparisonService.getPortfolioDetailWithRentTermForComparison(portfolioAnalysisInputModel).subscribe(response => {
        this.comparePropertyDetailModelList = response;
        this.getColumnTotalOrAvg();
        if (isFromNgOnInit) {
          this.modalRef.hide();
        }
        //else {
        let analyseListData = [];
        this.comparePropertyDetailModelList.forEach(item => {
          item.AcquisitionPrice = parseFloat(item.AcquisitionPrice.toFixed(2));
          item.IsChecked = true;
          this.analyzePropertyDetailModelList.push(item);
          if (item.LeaseCommencementYear != 0) {
            analyseListData.push(item.LeaseExpirationYear);
          }

          if (item.AcquisitionPrice != null && item.AcquisitionPrice != undefined && item.AcquisitionPrice != 0) {
            let updatedCapRate = parseFloat(((item.NOI / item.AcquisitionPrice) * 100).toFixed(2));
            item.CapRate = updatedCapRate;
          }
          else {
            item.CapRate = 0;
          }

        });
        analyseListData = analyseListData.sort();
        this.expirationYear = analyseListData[analyseListData.length - 1];

        this.analyze();
        this.showNodata = false;
        this.loaderService.display(false);
        // }
      }));

    }
    else {
      this.showNodata = false;
      this.loaderService.display(false);
    }
  }



  analyzePortfolio(fromHtml = false) {

    if (this.analyzePropertyDetailModelList.length > 1) {
      this.loadComparePropertyData(false);
    }
    else {
      if (fromHtml) {
        this._toastService.addToast({ title: 'Error Occurred', msg: 'Please select at least 2 properties', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      }
      else {
        this.showNodata = true;
      }
    }
  }

  openModalForAddProperty(template: TemplateRef<any>, classes: any) {
    this.disableAdd = true;
    this.disableAddButton = false;
    this.comparePropertiesModel.TenentIds = [];
    this.comparePropertyDetailCheckedModelList = [];
    this.addPropertyList = this.comparePropertiesModel.PropertyList;
    this.addPropertyList.forEach(item => {
      item.RemainingTerm = this.Validation.remainingTermForCardandTables(item.LeaseExpiration, item.CurrentDate);
      item.IsChecked = false;
    });

    this.comparePropertiesModel.PropertyIds.forEach(item => {
      this.addPropertyList = this.addPropertyList.filter(data => data.Id != item);
    });
    if (this.addPropertyList.length > 0) {
      // this.isAnalyze = false;
      //this.analyzePropertyDetailModelList = [];
      this.modalRef = this.modalService.show(template, { class: classes });
    }
    else {
      this._toastService.addToast({ title: 'No items Found!', msg: 'You picked all items from the Portfolio Analysis. Kindly add more properties to portfolio analysis and try again.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'warning' });
    }
    this.disableAdd = false;

  }

  addPropertyInComparisonList() {
    this.analyzePropertyDetailModelList = [];
    this.comparePropertiesModel.PropertyIds = this.comparePropertiesModel.PropertyIds.concat(this.comparePropertiesModel.TenentIds)
    this.comparePropertyDetailModelList = this.comparePropertyDetailModelList.concat(this.comparePropertyDetailCheckedModelList);
    this.comparePropertiesModel.TenentIds = [];
    this.comparePropertyDetailCheckedModelList = [];

    if (this.comparePropertiesModel.PropertyIds.length != this.comparePropertiesLength) {

      this.disableAddButton = true;
      this.loadComparePropertyData(true);
      this.comparePropertiesLength = this.comparePropertiesModel.PropertyIds.length;
    }
    else {
      this._toastService.addToast({ title: 'Error Occurred', msg: 'Please select at least a property', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
    }


  }

  onAddPropertyChecked(data) {

    //this.isAnalyze = false;
    if (data.IsChecked) {
      this.comparePropertiesModel.TenentIds.push(data.Id);
      this.comparePropertyDetailCheckedModelList.push(data);
    }
    else {
      const index: number = this.comparePropertiesModel.TenentIds.indexOf(data.Id);
      if (index !== -1) {
        this.comparePropertiesModel.TenentIds.splice(index, 1);
      }
    }
  }

  chekAnalyzeProperty(data, template: TemplateRef<any>, classes: any) {
    if (data.IsChecked) {
      this.analyzePropertyDetailModelList.push(data);
      this.comparePropertiesModel.PropertyIds.push(data.PropertyId);
    }
    else {
      this.uncheckedData = data;
      this.modalRef = this.modalService.show(template, { class: classes });
    }

    this.comparePropertiesLength = this.comparePropertiesModel.PropertyIds.length;

    //this.isAnalyze = false;
  }

  uncheckProperty() {
    if (this.uncheckedData != null && !this.uncheckedData.IsChecked) {
      if (this.comparePropertiesModel.PropertyIds.length <= 2) {
        this.cancelUncheckProperty();
        this._toastService.addToast({ title: 'Error Occurred', msg: 'Please select at least 2 properties', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      }
      else {
        const index: number = this.analyzePropertyDetailModelList.indexOf(this.uncheckedData);
        if (index !== -1) {
          this.analyzePropertyDetailModelList.splice(index, 1);
        }

        const index2: number = this.comparePropertiesModel.PropertyIds.indexOf(this.uncheckedData.PropertyId);
        if (index2 !== -1) {
          this.comparePropertiesModel.PropertyIds.splice(index2, 1);
        }
      }

      this.comparePropertiesLength = this.comparePropertiesModel.PropertyIds.length;
    }

    //this.isAnalyze = false;
    this.modalRef.hide();
  }

  cancelUncheckProperty() {
    if (this.uncheckedData != null && !this.uncheckedData.IsChecked) {

      let comparePropertyDetailModel: ComparePropertyDetailModel;
      comparePropertyDetailModel = this.comparePropertyDetailModelList.find(x => x.PropertyId == this.uncheckedData.PropertyId);
      comparePropertyDetailModel.IsChecked = true;
    }

    this.comparePropertiesLength = this.comparePropertiesModel.PropertyIds.length;
    this.isAnalyze = false;
    this.modalRef.hide();
  }

  deleteAnalyzeProperty(data) {

    //this.isAnalyze = false;
    const index2: number = this.comparePropertiesModel.PropertyIds.indexOf(data.PropertyId);

    if (this.comparePropertiesModel.PropertyIds.length <= 2 &&
      index2 != -1 && this.analyzePropertyDetailModelList.length <= 2) {
      this._toastService.addToast({ title: 'Error Occurred', msg: 'Please select at least 2 properties', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
    }
    else {
      const index: number = this.comparePropertyDetailModelList.indexOf(data);
      if (index !== -1) {
        this.comparePropertyDetailModelList.splice(index, 1);
      }

      const index1: number = this.analyzePropertyDetailModelList.indexOf(data);
      if (index1 !== -1) {
        this.analyzePropertyDetailModelList.splice(index1, 1);
      }


      if (index2 !== -1) {
        this.comparePropertiesModel.PropertyIds.splice(index2, 1);
      }
      this.comparePropertiesLength = this.comparePropertiesModel.PropertyIds.length;
      this.getColumnTotalOrAvg();
    }
  }

  getColumnTotalOrAvg(isAfterLoad: boolean = false) {

    this.comparePropertyDataTotalOrAvgModel.AskingPriceTotalOrAvg = 0;
    this.comparePropertyDataTotalOrAvgModel.AcquisitionPriceTotalOrAvg = Number(0);
    this.comparePropertyDataTotalOrAvgModel.BuildingSizeTotalOrAvg = 0;
    this.comparePropertyDataTotalOrAvgModel.CapRateTotalOrAvg = 0;
    this.comparePropertyDataTotalOrAvgModel.LandTotalOrAvg = 0;
    this.comparePropertyDataTotalOrAvgModel.NOITotalOrAvg = 0;
    this.comparePropertyDataTotalOrAvgModel.RemainingTermTotalOrAvg = 0;
    this.comparePropertyDataTotalOrAvgModel.ReturnDuringLeaseTotal = 0;
    this.maxCompareValues = new MaxValuesComparisonModel;

    this.comparePropertyDetailModelList.forEach(x => {

      x.ReturnDuringPrice = 0;

      if (isAfterLoad) {

        if (x.IsChecked) {

          if (x.AcquisitionPrice != null) {
            x.AcquisitionPrice = parseFloat(x.AcquisitionPrice.toFixed(2))
            this.comparePropertyDataTotalOrAvgModel.AcquisitionPriceTotalOrAvg = this.comparePropertyDataTotalOrAvgModel.AcquisitionPriceTotalOrAvg + x.AcquisitionPrice
            this.comparePropertyDataTotalOrAvgModel.AcquisitionPriceTotalOrAvg = Number(this.comparePropertyDataTotalOrAvgModel.AcquisitionPriceTotalOrAvg.toFixed(0))
          }

          //if (x.CapRate != null) {
          //    this.comparePropertyDataTotalOrAvgModel.CapRateTotalOrAvg = this.comparePropertyDataTotalOrAvgModel.CapRateTotalOrAvg + x.CapRate
          //}

          if (x.BuildingSize != null) {
            this.comparePropertyDataTotalOrAvgModel.BuildingSizeTotalOrAvg = this.comparePropertyDataTotalOrAvgModel.BuildingSizeTotalOrAvg + x.BuildingSize
          }


          //if (x.ReturnDuringPrice != null) {
          //    this.comparePropertyDataTotalOrAvgModel.ReturnDuringLeaseTotal = this.comparePropertyDataTotalOrAvgModel.ReturnDuringLeaseTotal + x.ReturnDuringPrice
          //}

          if (x.Land != null) {
            this.comparePropertyDataTotalOrAvgModel.LandTotalOrAvg = this.comparePropertyDataTotalOrAvgModel.LandTotalOrAvg + x.Land
          }

          if (x.RemainingTerm != null && x.RemainingTerm > 0) {
            this.comparePropertyDataTotalOrAvgModel.RemainingTermTotalOrAvg = this.comparePropertyDataTotalOrAvgModel.RemainingTermTotalOrAvg + x.RemainingTerm
          }

          //// calculation for Return during price
          if (x.NOI != null && x.RentEscalationPercentage != null && x.RentEscalationPercentage != 0) {
            var cYear = this.currentYear;
            var prevNOIValue = x.NOI;
            var period = this.currentYear;


            if (x.LeaseExpirationYear > this.leaseExpirationYear) {
              this.leaseExpirationYear = x.LeaseExpirationYear;

            }

            if (x.RentTermList != undefined && x.RentTermList.length > 0) {
              var startDate = this.Validation.convertUTCDateToLocalDate(x.RentTermList[0].LeaseStartDate);
              var endDate;
              x.RentTermList.forEach(item => {
                if (!item.IsOptional) {
                  x.ReturnDuringPrice = +(item.NetOperatingIncome).toFixed() + x.ReturnDuringPrice;
                  endDate = item.LeaseEndDate;
                }
              });
              endDate = this.Validation.convertUTCDateToLocalDate(endDate);
              var months;
              months = (endDate.getFullYear() - startDate.getFullYear()) * 12;
              months -= startDate.getMonth() + 1;
              months += endDate.getMonth();

              //x.NOI = +(x.ReturnDuringPrice / months).toFixed() * 12
            } else {

              while (x.LeaseExpirationYear >= cYear) {
                if (period == cYear && period != this.currentYear) {
                  var res = 0;
                  res = Math.round((prevNOIValue * x.RentEscalationPercentage) / 100);
                  prevNOIValue = res + prevNOIValue;
                  period = period + x.RentEscalationPeriod;
                  x.ReturnDuringPrice = x.ReturnDuringPrice + prevNOIValue;
                }
                else {
                  x.ReturnDuringPrice = x.ReturnDuringPrice + prevNOIValue;
                }

                if (cYear == this.currentYear) {
                  period = period + x.RentEscalationPeriod;
                }

                cYear++;
              }
            }
          }

          if (x.NOI != null) {
            this.comparePropertyDataTotalOrAvgModel.NOITotalOrAvg = this.comparePropertyDataTotalOrAvgModel.NOITotalOrAvg + x.NOI
          }
          // For Highlighte Max Rates

          if (x.AskingPrice > this.maxCompareValues.MaxAskingPrice) {
            this.maxCompareValues.MaxAskingPrice = x.AskingPrice;
          }
          if (x.AcquisitionPrice > this.maxCompareValues.MaxAcquisitionPrice) {
            this.maxCompareValues.MaxAcquisitionPrice = parseFloat(x.AcquisitionPrice.toFixed(2));
          }
          if (x.NOI > this.maxCompareValues.MaxNOI) {
            this.maxCompareValues.MaxNOI = x.NOI;
          }
          if (x.CapRate > this.maxCompareValues.MaxCapRate) {
            this.maxCompareValues.MaxCapRate = x.CapRate;
          }
          if (x.ReturnDuringPrice > this.maxCompareValues.MaxReturnDuringPrice) {
            this.maxCompareValues.MaxReturnDuringPrice = x.ReturnDuringPrice;
          }

          if (x.RemainingTerm > this.maxCompareValues.MaxRemainingTerm) {
            this.maxCompareValues.MaxRemainingTerm = x.RemainingTerm;
          }
          if (x.BuildingSize > this.maxCompareValues.MaxBuildingSize) {
            this.maxCompareValues.MaxBuildingSize = x.BuildingSize;
          }
          if (x.Land > this.maxCompareValues.MaxLand) {
            this.maxCompareValues.MaxLand = x.Land;
          }
          if (x.YearBuilt > this.maxCompareValues.MaxYearBuilt) {
            this.maxCompareValues.MaxYearBuilt = x.YearBuilt;
          }


          if (x.ReturnDuringPrice != null) {
            this.comparePropertyDataTotalOrAvgModel.ReturnDuringLeaseTotal = this.comparePropertyDataTotalOrAvgModel.ReturnDuringLeaseTotal + x.ReturnDuringPrice;
            x.ReturnDuringPrice = Number(x.ReturnDuringPrice.toFixed(2));
          }

        }
      }

      else {
        {

          if (x.AskingPrice != null) {
            this.comparePropertyDataTotalOrAvgModel.AskingPriceTotalOrAvg = this.comparePropertyDataTotalOrAvgModel.AskingPriceTotalOrAvg + x.AskingPrice
          }

          if (x.AcquisitionPrice != null) {
            x.AcquisitionPrice = parseFloat(x.AcquisitionPrice.toFixed(2))
            this.comparePropertyDataTotalOrAvgModel.AcquisitionPriceTotalOrAvg = this.comparePropertyDataTotalOrAvgModel.AcquisitionPriceTotalOrAvg + x.AcquisitionPrice
          }

          //if (x.CapRate != null) {
          //    this.comparePropertyDataTotalOrAvgModel.CapRateTotalOrAvg = this.comparePropertyDataTotalOrAvgModel.CapRateTotalOrAvg + x.CapRate
          //}

          if (x.BuildingSize != null) {
            this.comparePropertyDataTotalOrAvgModel.BuildingSizeTotalOrAvg = this.comparePropertyDataTotalOrAvgModel.BuildingSizeTotalOrAvg + x.BuildingSize
          }


          //if (x.ReturnDuringPrice != null) {
          //    this.comparePropertyDataTotalOrAvgModel.ReturnDuringLeaseTotal = this.comparePropertyDataTotalOrAvgModel.ReturnDuringLeaseTotal + x.ReturnDuringPrice
          //}

          if (x.Land != null) {
            this.comparePropertyDataTotalOrAvgModel.LandTotalOrAvg = this.comparePropertyDataTotalOrAvgModel.LandTotalOrAvg + x.Land
          }

          if (x.RemainingTerm != null && x.RemainingTerm > 0) {
            this.comparePropertyDataTotalOrAvgModel.RemainingTermTotalOrAvg = this.comparePropertyDataTotalOrAvgModel.RemainingTermTotalOrAvg + x.RemainingTerm
          }

          //// calculation for Return during price
          if (x.NOI != null && x.RentEscalationPercentage != null && x.RentEscalationPercentage != 0) {
            var cYear = this.currentYear;
            var prevNOIValue = x.NOI;
            var period = this.currentYear;


            if (x.LeaseExpirationYear > this.leaseExpirationYear) {
              this.leaseExpirationYear = x.LeaseExpirationYear;

            }

            if (x.RentTermList != undefined && x.RentTermList.length > 0) {
              var startDate = this.Validation.convertUTCDateToLocalDate(x.RentTermList[0].LeaseStartDate);
              var endDate;
              x.RentTermList.forEach(item => {
                if (!item.IsOptional) {
                  x.ReturnDuringPrice = +(item.NetOperatingIncome).toFixed() + x.ReturnDuringPrice;
                  endDate = item.LeaseEndDate;
                }
              });
              endDate = this.Validation.convertUTCDateToLocalDate(endDate);
              var months;
              months = (endDate.getFullYear() - startDate.getFullYear()) * 12;
              months -= startDate.getMonth() + 1;
              months += endDate.getMonth();

              //x.NOI = +(x.ReturnDuringPrice / months).toFixed() * 12
            } else {

              while (x.LeaseExpirationYear >= cYear) {
                if (period == cYear && period != this.currentYear) {
                  var res = 0;
                  res = Math.round((prevNOIValue * x.RentEscalationPercentage) / 100);
                  prevNOIValue = res + prevNOIValue;
                  period = period + x.RentEscalationPeriod;
                  x.ReturnDuringPrice = x.ReturnDuringPrice + prevNOIValue;
                }
                else {
                  x.ReturnDuringPrice = x.ReturnDuringPrice + prevNOIValue;
                }

                if (cYear == this.currentYear) {
                  period = period + x.RentEscalationPeriod;
                }

                cYear++;
              }
            }
          }

          if (x.NOI != null) {
            this.comparePropertyDataTotalOrAvgModel.NOITotalOrAvg = this.comparePropertyDataTotalOrAvgModel.NOITotalOrAvg + x.NOI
          }
          // For Highlighte Max Rates

          if (x.AskingPrice > this.maxCompareValues.MaxAskingPrice) {
            this.maxCompareValues.MaxAskingPrice = x.AskingPrice;
          }
          if (x.AcquisitionPrice > this.maxCompareValues.MaxAcquisitionPrice) {
            this.maxCompareValues.MaxAcquisitionPrice = x.AcquisitionPrice;
          }
          if (x.NOI > this.maxCompareValues.MaxNOI) {
            this.maxCompareValues.MaxNOI = x.NOI;
          }
          if (x.CapRate > this.maxCompareValues.MaxCapRate) {
            this.maxCompareValues.MaxCapRate = x.CapRate;
          }
          if (x.ReturnDuringPrice > this.maxCompareValues.MaxReturnDuringPrice) {
            this.maxCompareValues.MaxReturnDuringPrice = x.ReturnDuringPrice;
          }

          if (x.RemainingTerm > this.maxCompareValues.MaxRemainingTerm) {
            this.maxCompareValues.MaxRemainingTerm = x.RemainingTerm;
          }
          if (x.BuildingSize > this.maxCompareValues.MaxBuildingSize) {
            this.maxCompareValues.MaxBuildingSize = x.BuildingSize;
          }
          if (x.Land > this.maxCompareValues.MaxLand) {
            this.maxCompareValues.MaxLand = x.Land;
          }
          if (x.YearBuilt > this.maxCompareValues.MaxYearBuilt) {
            this.maxCompareValues.MaxYearBuilt = x.YearBuilt;
          }


          if (x.ReturnDuringPrice != null) {
            this.comparePropertyDataTotalOrAvgModel.ReturnDuringLeaseTotal = this.comparePropertyDataTotalOrAvgModel.ReturnDuringLeaseTotal + x.ReturnDuringPrice;
            x.ReturnDuringPrice = Number(x.ReturnDuringPrice.toFixed(2));
          }

        }
      }

    });

    //if (this.comparePropertyDataTotalOrAvgModel.CapRateTotalOrAvg != 0) {
    if (this.comparePropertyDataTotalOrAvgModel.AcquisitionPriceTotalOrAvg == 0) {
      this.comparePropertyDataTotalOrAvgModel.CapRateTotalOrAvg = null;
    }
    else {
      this.comparePropertyDataTotalOrAvgModel.CapRateTotalOrAvg = (this.comparePropertyDataTotalOrAvgModel.NOITotalOrAvg / this.comparePropertyDataTotalOrAvgModel.AcquisitionPriceTotalOrAvg) * 100;
      this.comparePropertyDataTotalOrAvgModel.CapRateTotalOrAvg = Number(this.comparePropertyDataTotalOrAvgModel.CapRateTotalOrAvg.toFixed(2));
    }
    // }

    if (this.comparePropertyDataTotalOrAvgModel.RemainingTermTotalOrAvg != 0) {
      this.comparePropertyDataTotalOrAvgModel.RemainingTermTotalOrAvg = this.comparePropertyDataTotalOrAvgModel.RemainingTermTotalOrAvg / this.comparePropertyDetailModelList.length
    }

    if (this.comparePropertyDataTotalOrAvgModel.ReturnDuringLeaseTotal != 0) {
      this.comparePropertyDataTotalOrAvgModel.ReturnDuringLeaseTotal = Number(this.comparePropertyDataTotalOrAvgModel.ReturnDuringLeaseTotal.toFixed(2));
    }
  }

  saveAnalyze() {
    if (this.isSaveDisabled == false) {
      this.isSaveDisabled = true;
      if (this.comparePropertiesModel.Name != null && this.comparePropertiesModel.Name != undefined && this.comparePropertiesModel.Name != '') {
        let portfolioAnalysisInputModel = {} as PortfolioAnalysisInputModel;
        portfolioAnalysisInputModel.Name = this.comparePropertiesModel.Name;
        portfolioAnalysisInputModel.UserId = this.comparePropertiesModel.UserId;
        portfolioAnalysisInputModel.UserGuid = this.UserGuid;
        portfolioAnalysisInputModel.PropertyIds = [];
        portfolioAnalysisInputModel.DataEntryPropertyIds = [];
        this.comparePropertiesModel.PropertyIds.forEach(item => {
          if (this.comparePropertiesModel.PropertyList.find(p => p.Id == item && p.IsCreated == 0) != undefined) {
            portfolioAnalysisInputModel.PropertyIds.push(item);
          }
          else if (this.comparePropertiesModel.PropertyList.find(p => p.Id == item && p.IsCreated == 1) != undefined) {
            portfolioAnalysisInputModel.DataEntryPropertyIds.push(item);
          }
        });

        this.subscriptions.push(this._comparisonService.savePortfolioAnalysis(portfolioAnalysisInputModel).subscribe(response => {
          if (response) {

            this._toastService.addToast({ title: 'Success', msg: 'Saved Successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
            this._comparisonService.isComparePage = false;
            //this.comparePropertiesModel.PropertyIds = [];
            this.modalRef.hide();
            //  this.isSaveDisabled = false;
          }

        }));
      }
      else {
        this.isAnalyzeName = true;
        this.isSaveDisabled = false;
      }
    }
  }

  bindPriceChart() {
    const chartData = [];
    const chartXData = [];
    //this.priceChart = new Chart();
    let chartCount = 0;
    this.analyzePropertyDetailModelList.forEach(item => {
      const serieData = {
        name: item.PropertyName + " ($" + this.Validation.commaFormat(item.AskingPrice) + ")",
        y: item.AskingPrice,
        z: item.AskingPrice,
        color: this.getChartColor(chartCount)
      }
      chartData.push(serieData);
      chartXData.push(item.PropertyName);
      chartCount++;
    });

    Highcharts.chart('priceChart', {
      chart: {
        renderTo: 'priceChart',
        type: this.isFromOfferPortfolio ? 'variablepie' : this.isPropertyAnalysis ? 'column' : 'pie'
      },
      title: {
        text: ''
      },
      credits: {
        enabled: false
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,

            format: '{point.percentage:.1f} %',
            distance: -50,
          },
          showInLegend: true
        }
      },
      series: [{
        type: undefined,
        innerSize: this.isFromOfferPortfolio ? '20%' : "0%",
        name: 'Price',
        data: chartData
      }],
      legend: {
        enabled: this.isPropertyAnalysis || this.isFromOfferPortfolio ? false : true,

      },
      xAxis: {
        categories: chartXData
      },
      yAxis: [{
        labels: {
          formatter: function () {
            return +this.value / 1000000 + "M";
          }
        },
        title: {
          text: 'Price ($)'
        }

      }],

      tooltip: {
        formatter: function () {
          let index = this.series.data.indexOf(this.point);
          var priceValue = this.series.data[index].y.toString();
          let propertyName = this.series.data[index].name;
          priceValue += '';
          var x = priceValue.split('.');
          var x1 = x[0];
          var x2 = x.length > 1 ? '.' + x[1] : '';
          var rgx = /(\d+)(\d{3})/;
          while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
          }

          // return "<b>" + propertyName + " </b><br/>Price :- $" + x1 + x2;
          return "<b>" + propertyName + " </b>";
        }
      }
    });
  }

  bindNOIChart() {

    const chartData = [];
    const chartXData = [];
    let chartCount = 0;
    this.analyzePropertyDetailModelList.forEach(item => {
      const serieData = {
        name: item.PropertyName + " ($" + this.Validation.commaFormat(item.NOI) + ")",
        y: item.NOI,
        z: item.NOI,
        color: this.getChartColor(chartCount)
      }
      chartData.push(serieData);
      chartXData.push(item.PropertyName);
      chartCount++;

    });

    Highcharts.chart('NOIChart', {
      chart: {
        renderTo: 'NOIChart',
        type: this.isFromOfferPortfolio ? 'variablepie' : this.isPropertyAnalysis ? 'column' : 'pie'
      },
      title: {
        text: ''
      },
      credits: {
        enabled: false
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,

            format: '{point.percentage:.1f} %',
            distance: -50,
          },
          showInLegend: true
        }
      },
      series: [{
        type: undefined,
        innerSize: this.isFromOfferPortfolio ? '20%' : "0%",
        name: 'NOI',
        data: chartData
      }],
      legend: {
        enabled: this.isFromOfferPortfolio || this.isPropertyAnalysis ? false : true,

      },
      xAxis: {
        categories: chartXData
      },
      yAxis: [{
        labels: {
          formatter: function () {
            return +this.value / 1000000 + "M";
          }
        },
        title: {
          text: 'NOI ($)'
        }

      }],
      tooltip: {
        formatter: function () {
          let index = this.series.data.indexOf(this.point);
          var priceValue = this.series.data[index].y.toString();
          let propertyName = this.series.data[index].name;
          priceValue += '';
          var x = priceValue.split('.');
          var x1 = x[0];
          var x2 = x.length > 1 ? '.' + x[1] : '';
          var rgx = /(\d+)(\d{3})/;
          while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
          }

          //return "<b>" + propertyName + " </b><br/>NOI :- $" + x1 + x2;
          return "<b>" + propertyName + " </b>";
        }
      }
    });

  }

  bindReturnDuringLeaseChart() {

    const chartData = [];
    const chartXData = [];
    let chartCount = 0;
    this.analyzePropertyDetailModelList.forEach(item => {
      const serieData = {
        name: item.PropertyName,
        y: (Math.round(item.ReturnDuringPrice * 100) / 100),
        z: (Math.round(item.ReturnDuringPrice * 100) / 100),
        color: this.getChartColor(chartCount)
      }
      chartData.push(serieData);
      chartXData.push(item.PropertyName);
      chartCount++;
    });

    Highcharts.chart('returnDuringLeaseChart', {
      chart: {
        renderTo: 'returnDuringLeaseChart',
        type: this.isFromOfferPortfolio ? 'variablepie' : this.isPropertyAnalysis ? 'column' : 'pie'
      },
      title: {
        text: ''
      },
      credits: {
        enabled: false
      },
      series: [{
        type: undefined,
        innerSize: this.isFromOfferPortfolio ? '20%' : "0%",
        name: 'Return During Lease',
        data: chartData
      }],
      xAxis: {
        categories: chartXData
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,

            format: '{point.percentage:.1f} %',
            distance: -50,
          },
          showInLegend: true
        }
      },
      legend: {
        enabled: this.isFromOfferPortfolio || this.isPropertyAnalysis ? false : true,
      },
      yAxis: [{
        labels: {
          formatter: function () {
            return +this.value / 1000000 + "M";
          }
        },
        title: {
          text: 'Return During Lease ($)'
        }

      }],
      tooltip: {
        formatter: function () {
          let index = this.series.data.indexOf(this.point);
          let priceValue = this.series.data[index].y.toString();
          let propertyName = this.series.data[index].name;
          priceValue += '';
          var x = priceValue.split('.');
          var x1 = x[0];
          var x2 = x.length > 1 ? '.' + x[1] : '';
          var rgx = /(\d+)(\d{3})/;
          while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
          }

          return "<b>" + propertyName + " </b><br/>Return During Lease:- $" + x1 + x2;
        }
      }
    });

  }

  bindRemainingTermChart() {

    const chartData = [];
    const chartXData = [];
    let chartCount = 0;

    this.analyzePropertyDetailModelList.forEach(item => {
      if (item.RemainingTerm != null && item.RemainingTerm > 0) {

        var result = parseFloat(this.yearMonthConverter(item.RemainingTerm, true));
        // var s = parseFloat(Number(this.yearMonthConverter(item.RemainingTerm, true)).toFixed(2));
        //var remainingTermData = +result;
        const serieData = {
          name: item.PropertyName,
          y: result,
          color: this.getChartColor(chartCount)
        }
        chartData.push(serieData);
        chartXData.push(item.PropertyName);
        chartCount++;
      }

    });

    Highcharts.chart('remainingTermChart', {
      chart: {
        renderTo: 'remainingTermChart',
        type: 'column'
      },
      title: {
        text: ''
      },
      credits: {
        enabled: false
      },
      xAxis: {
        categories: chartXData,
      },
      yAxis: {
        title: {
          text: 'Years',
        }
      },
      legend: {
        enabled: false,
      },
      series: [{
        type: undefined,
        name: 'Remaining Term',
        data: chartData
      }],
      tooltip: {
        formatter: function () {
          let index = this.series.data.indexOf(this.point);
          var rm = this.series.data[index].y;
          let propertyName = this.series.data[index].name;

          return "<b>" + propertyName + " </b><br/> Remaining Term:- " + rm + " Years";
        }
      }
    });

  }

  bindLandAreaChart() {

    const chartData = [];
    let chartCount = 0;

    this.analyzePropertyDetailModelList.forEach(item => {

      const serieData = {
        name: item.PropertyName,
        data: [item.Land],
        color: this.getChartColor(chartCount)
        // colorByPoint: true
        // color: '#' + Math.random().toString(16).slice(2, 8)
      }
      chartData.push(serieData);
      chartCount++;
    });

    const plotOptions = {
      colorByPoint: true
    }

    Highcharts.chart('landAreaChart', {
      chart: {
        renderTo: 'landAreaChart',
        type: 'column'
      },
      title: {
        text: ''
      },
      credits: {
        enabled: false,
      },
      xAxis: {
        categories: [''],
        visible: false
      },
      yAxis: {
        title: {
          text: 'Acres',
        }
      },
      plotOptions: {
        series: {

        }
      },
      legend: {
        enabled: true,
      },
      series: chartData
    });

  }

  bindCreditRatingChart() {

    const chartData = [];
    const creditRatingData = [];
    var totalPrice = 0;

    this.analyzePropertyDetailModelList.forEach(item => {
      totalPrice = totalPrice + item.AskingPrice
    });

    this.analyzePropertyDetailModelList.forEach(item => {
      const CRData = {
        propertyName: item.PropertyName,
        rating: item.Rating != null ? item.Rating : 0,
        // pricePercentage: ((item.AskingPrice / totalPrice) * 100)
        pricePercentage: (Math.round(((item.AskingPrice / totalPrice) * 100) * 100) / 100),
      }
      creditRatingData.push(CRData);
    });

    const resultList = [];
    var result = this.groupBy(creditRatingData, function (item) {
      return [item.rating];
    });
    resultList.push(result);
    let chartCount = 0;
    resultList.forEach(item => {

      item.forEach(data => {

        this.priceTotal = 0;
        let propertyName = "";
        if (data.length > 1) {
          data.forEach(res => {
            this.priceTotal = this.priceTotal + res.pricePercentage
            propertyName = propertyName + "<br/>" + res.propertyName
          });
          const serieData = {
            name: "<br/> Credit Rating - " + data[0].rating + '(' + data.length + ' prop)' + "<br/>" + propertyName,
            y: this.priceTotal,
            z: this.priceTotal,
            color: this.getChartColor(chartCount)
          }
          chartData.push(serieData);
          chartCount++;
        }
        else {
          const serieData1 = {
            //name: data[0].rating,
            name: "<br/> Credit Rating - " + data[0].rating + "<br/>" + data[0].propertyName,
            y: data[0].pricePercentage,
            z: data[0].pricePercentage,
            color: this.getChartColor(chartCount)
          }
          chartData.push(serieData1);
          chartCount++;
        }
      });
    });

    Highcharts.chart('creditRatingChart', {
      chart: {
        renderTo: 'creditRatingChart',
        type: this.isFromOfferPortfolio ? 'variablepie' : 'pie'
      },
      title: {
        text: ''
      },
      credits: {
        enabled: false
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,

            format: '{point.percentage:.1f} %',
            distance: -50,
          },
          showInLegend: true
        }
      },
      legend: {
        enabled: this.isFromOfferPortfolio || this.isPropertyAnalysis ? false : true,
      },
      series: [{
        type: undefined,
        innerSize: this.isFromOfferPortfolio ? '20%' : "0%",
        name: 'Credit Rating (%)',
        data: chartData
      }],
      tooltip: {
        formatter: function () {
          let index = this.series.data.indexOf(this.point);
          let name = this.series.data[index].name;

          return name;
        }
      }
    });
  }

  bindCapRateChartForPrpertyAnalysis() {


    const chartData = [];
    const chartXData = [];
    let chartCount = 0;
    this.analyzePropertyDetailModelList.forEach(item => {

      const serieData = {
        name: item.PropertyName,
        y: item.CapRate != null ? item.CapRate : 0,
        color: this.getChartColor(chartCount)
      }
      chartData.push(serieData);
      chartXData.push(item.PropertyName);
      chartCount++;
    });

    Highcharts.chart('capRateChart', {
      chart: {
        renderTo: 'capRateChart',
        type: 'column'
      },
      title: {
        text: ''
      },
      credits: {
        enabled: false
      },
      legend: {
        enabled: false,
      },
      yAxis: [{
        title: {
          text: 'Cap Rate (%)'
        }

      }],
      series: [{
        type: undefined,
        name: 'Cap Rate (%)',
        data: chartData
      }],
      xAxis: {
        categories: chartXData
      },
      tooltip: {
        formatter: function () {
          let index = this.series.data.indexOf(this.point);
          var priceValue = this.series.data[index].y;
          let propertyName = this.series.data[index].name;


          return "<b>" + propertyName + " </b><br/>Cap Rate :- " + priceValue;
        }
      }
    });
  }

  bindCapRateChart() {

    const chartData = [];
    const capRateData = [];
    var totalPrice = 0;
    this.analyzePropertyDetailModelList.forEach(item => {
      totalPrice = totalPrice + (item.AcquisitionPrice != null ? item.AcquisitionPrice : 0)
    });

    this.analyzePropertyDetailModelList.forEach(item => {

      // if (item.CapRate != null) {
      const CRData = {
        propertyName: item.PropertyName,
        capRate: item.CapRate != null ? item.CapRate : 0,
        pricePercentage: (((item.AcquisitionPrice != null ? item.AcquisitionPrice:0) / totalPrice) * 100)
        // pricePercentage:(Math.round(((item.AskingPrice / totalPrice) * 100) * 100) / 100),
      }
      capRateData.push(CRData);
      // }
    });

    const resultList = [];
    var result = this.groupBy(capRateData, function (item) {
      return [item.capRate];
    });
    resultList.push(result);
    let chartCount = 0;
    resultList.forEach(item => {

      item.forEach(data => {

        this.priceTotal = 0;
        let propertyName = "";
        if (data.length > 1) {
          data.forEach(res => {
            this.priceTotal = this.priceTotal + res.pricePercentage;
            propertyName = propertyName + "<br/>" + res.propertyName;
          });
          const serieData = {
            name: "<br/> Cap Rate - " + data[0].capRate + '% (' + data.length + ' prop)' + "<br/>" + propertyName,
            ////y: (Math.round(this.priceTotal * 100) / 100),
            ////z: (Math.round(this.priceTotal * 100) / 100),                        
            y: data[0].capRate,
            z: data[0].capRate,
            color: this.getChartColor(chartCount)
          }
          chartData.push(serieData);
          chartCount++;
        }
        else {
          const serieData1 = {
            // name: data[0].capRate,
            //y: data[0].pricePercentage,
            name: "<br/> Cap Rate - " + data[0].capRate + "% <br/>" + data[0].propertyName,
            y: (Math.round(data[0].capRate * 100) / 100),
            z: (Math.round(data[0].capRate * 100) / 100),
            color: this.getChartColor(chartCount)
          }
          chartData.push(serieData1);
          chartCount++;
        }
      });
    });

    Highcharts.chart('capRateChart', {
      chart: {
        renderTo: 'capRateChart',
        type: this.isFromOfferPortfolio ? "variablepie" : this.isPropertyAnalysis ? 'column' : 'pie'
      },
      title: {
        text: ''
      },
      credits: {
        enabled: false
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,

            format: '{point.percentage:.1f} %',
            distance: -50,
          },
          showInLegend: true
        }
      },
      legend: {
        enabled: this.isPropertyAnalysis ? false : true,
      },
      series: [{
        type: undefined,
        innerSize: this.isFromOfferPortfolio ? '20%' : "0%",
        name: 'Cap Rate (%)',
        data: chartData
      }],
      tooltip: {
        formatter: function () {
          let index = this.series.data.indexOf(this.point);
          let name = this.series.data[index].name;

          return name;
        }
      }
    });
  }

  bindRevenueChart() {

    const chartData = [];
    this.leaseExpirationYear = this.currentYear;
    var xAxisData = [];
    xAxisData = [];

    const lineChartData = new Array(1);
    lineChartData[0] = 0;
    let lineChartData2 = [];
    lineChartData2[0] = 0;
    let chartCount = 0;
    this.analyzePropertyDetailModelList.forEach(item => {

      //var linechart = [];
      //var lineOptionChart = [];
      const data = [];
      if (item.RentTermList != undefined && item.RentTermList.length > 0) {
        var chartStartYear = this.currentYear;
        let count = 0;
        item.RentTermList.forEach(rentTerm => {

          var startDate = this.Validation.convertUTCDateToLocalDate(rentTerm.LeaseStartDate);
          var startYear = startDate.getFullYear();
          var endDate = this.Validation.convertUTCDateToLocalDate(rentTerm.LeaseEndDate);
          var endYear = endDate.getFullYear();
          var yearDiff = endDate.getFullYear() - startDate.getFullYear()
          yearDiff = yearDiff > 0 ? yearDiff : 1;
          let k = yearDiff == 1 ? 1 : 0;

          for (let i = k; i <= yearDiff; i++) {
            while (chartStartYear < startYear) {
              if (!rentTerm.IsOptional) {
                data.push(null);
                if (lineChartData[count] == undefined) {
                  lineChartData.push(null);
                }
              }

              if (lineChartData2[count] == undefined) {
                lineChartData2.push(null);
              }
              chartStartYear++;
              count++;
            }

            if (chartStartYear == startYear) {
              if (!rentTerm.IsOptional) {
                data.push(rentTerm.NetOperatingIncome)
                if (lineChartData[count] != undefined) {
                  lineChartData[count] = lineChartData[count] + rentTerm.NetOperatingIncome;
                }
                else {
                  lineChartData.push(rentTerm.NetOperatingIncome);
                }
              }

              if (lineChartData2[count] != undefined) {
                lineChartData2[count] = lineChartData2[count] + rentTerm.NetOperatingIncome;
              }
              else {
                lineChartData2.push(rentTerm.NetOperatingIncome);
              }

              if (xAxisData.indexOf(chartStartYear) == -1) {
                xAxisData.push(chartStartYear);
              }
              chartStartYear++;
              count++;
            }
            startYear++;
          }
        })

        const serieData = {
          name: item.PropertyName,
          data: data,
          type: 'column',
          color: this.getChartColor(chartCount)
        }
        chartData.push(serieData);
        chartCount++;
      }
      else {
        if (item.NOI != null && item.RentEscalationPercentage != null && item.RentEscalationPercentage != 0) {
          var chartStartYear = this.currentYear;
          var commencementYear = item.LeaseCommencementYear;
          var prevNOIValue = item.NOI;
          var extendedNOIValue = item.NOI;
          var period = item.LeaseCommencementYear;

          if (item.LeaseExpirationYear > this.leaseExpirationYear) {
            this.leaseExpirationYear = item.LeaseExpirationYear;
          }

          let count = 0;
          while (this.expirationYear >= commencementYear) {

            if (period == commencementYear && period != item.LeaseCommencementYear) {
              var res = 0;
              res = ((prevNOIValue * item.RentEscalationPercentage) / 100);
              res = Math.round(res * 100) / 100;
              prevNOIValue = Math.round(res + prevNOIValue);

              res = 0;
              res = ((extendedNOIValue * item.RentEscalationPercentage) / 100);
              res = Math.round(res * 100) / 100;
              extendedNOIValue = Math.round(res + extendedNOIValue);

              if (commencementYear >= chartStartYear && item.LeaseExpirationYear >= commencementYear) {
                data.push(prevNOIValue);
              }
              period = period + item.RentEscalationPeriod;
            }
            else if (commencementYear >= chartStartYear && item.LeaseExpirationYear >= commencementYear) {
              data.push(prevNOIValue);
            }

            if (this.leaseExpirationYear == item.LeaseExpirationYear && commencementYear >= chartStartYear && xAxisData.indexOf(commencementYear) == -1) {
              xAxisData.push(commencementYear);
            }

            if (commencementYear == item.LeaseCommencementYear) {
              period = period + item.RentEscalationPeriod;
            }
            if (commencementYear >= chartStartYear) {
              if (item.LeaseExpirationYear >= commencementYear) {
                if (lineChartData[count] != undefined && lineChartData[count] != null) {
                  lineChartData[count] = lineChartData[count] + (prevNOIValue == null ? 0 : prevNOIValue);
                }
                else {
                  lineChartData.push((prevNOIValue == null ? 0 : prevNOIValue));
                }
              }

              if (lineChartData2[count] != undefined && lineChartData2[count] != null) {
                lineChartData2[count] = lineChartData2[count] + extendedNOIValue;
              }
              else {
                lineChartData2.push(extendedNOIValue);
              }

              count++;
            }
            commencementYear++;

          }
          const serieData = {
            name: item.PropertyName,
            data: data,
            type: 'column',
            color: this.getChartColor(chartCount)
          }
          chartData.push(serieData);
          chartCount++;
        }
      }
    });

    if (!this.isPropertyAnalysis) {
      if (lineChartData.length > xAxisData.length) {
        let diff = xAxisData[xAxisData.length - 1] - xAxisData[xAxisData.length - 2];
        while (!(lineChartData.length == xAxisData.length || lineChartData.length < xAxisData.length)) {
          xAxisData.push(xAxisData[xAxisData.length - 1] + diff);
        }
      }

      const lineData = {
        type: 'spline',
        name: 'Total NOI',
        data: lineChartData
      }
      chartData.push(lineData);

      if (this.enableExtendedChart) {
        if (lineChartData2.length > xAxisData.length) {
          let diff = xAxisData[xAxisData.length - 1] - xAxisData[xAxisData.length - 2];
          while (!(lineChartData2.length == xAxisData.length || lineChartData2.length < xAxisData.length)) {
            xAxisData.push(xAxisData[xAxisData.length - 1] + diff);
          }
        }
        const lineData2 = {
          type: 'spline',
          name: 'Total Extended NOI',
          data: lineChartData2
        }
        chartData.push(lineData2);
      }
    }

    Highcharts.chart('revenueChart', {
      title: {
        text: ''
      },
      credits: {
        enabled: false,
      },
      xAxis: {
        categories: xAxisData,
        //visible: false
        title: {
          text: 'Years',
        },
        min: 0
      },
      yAxis: {
        labels: {
          formatter: function () {
            return +this.value / 1000000 + "M";
          }
        },
        title: {
          text: 'NOI',
        }
      },
      plotOptions: {
        series: {
          connectNulls: true
        }
      },
      legend: {
        enabled: true,
      },
      series: chartData,
      tooltip: {
        formatter: function () {
          let index = this.series.data.indexOf(this.point);
          let priceValue = this.series.data[index].y.toString();
          let propertyNameData = this.series.name;
          priceValue += '';
          var x = priceValue.split('.');
          var x1 = x[0];
          var x2 = x.length > 1 ? '.' + x[1] : '';
          var rgx = /(\d+)(\d{3})/;
          while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
          }

          return "<b>" + propertyNameData + " </b><br/>NOI :- $" + x1 + x2;
        }
      }
    });

  }

  yearMonthConverter(valuex: number | string, abbr?: boolean): string {

    if (!valuex) {
      return '-';
    }

    const value = parseFloat(valuex.toString());

    // (int)Math.Floor(x.LeaseExpiration.Value.Subtract(DateTime.Now).Days / (365.25 / 12))
    const months = Math.floor((value / (365.25 / 12))); // actual months

    const years = Math.floor(months / 12);

    const yrs = years > 1 ? (abbr ? 'yrs' : 'years') : (abbr ? 'yr' : 'year');
    const mnts = (months % 12) > 1 ? (abbr ? 'mo' : 'months') : (abbr ? 'mo' : 'month');

    const days = +valuex > 1 ? 'days' : (abbr ? 'd' : 'day');

    if (years > 0 && (months % 12) === 0) {
      return `${years}`;
    } else if (years === 0 && (months % 12) > 0) {
      return `.${(months % 12)}`;
    } else if ((years < 1 && months < 1) || (years === 0 && months === 0)) {

      if (years === 0 && months === 0 && +valuex > 0) {
        return `.${valuex}`;
      }

      return `Expired`;
    } else {
      return `${years}.${(months % 12)}`;
    }
  }

  groupBy(array, f) {
    var groups = {};
    array.forEach(function (o) {
      var group = JSON.stringify(f(o));
      groups[group] = groups[group] || [];
      groups[group].push(o);
    });
    return Object.keys(groups).map(function (group) {
      return groups[group];
    })
  }

  getChartColor(index) {
    const colors = ['#198FDE', '#003A5D', '#59595B', '#02C29F', '#A7A8A9', '#FFC32B', '#FF4438', ' #6596D6 ', ' #67A7FA ', ' #1967CB ', ' #0D77FF ', ' #004298 ', ' #285CA1 ', ' #55759E ', ' #4788DC ', ' #5167EA ', ' #2B44D8 ', ' #7582CF ', ' #4354B9 ', ' #0F24A4 ', ' #1458E2 ', ' #3562BF ', ' #305297 ', ' #333286 ', ' #98C7FF ', ' #4886D8 ', ' #2C99D7 ', ' #157BB5 ', ' #0C6699 ', ' #49A1D3 ', ' #62BFF3 ', ' #51B5D1 ', ' #6186D3 ', ' #33C5DF ', ' #21A5BC ', ' #277583 ', ' #274183 ', ' #21459E ', ' #4674E6 ', ' #3355AA ', ' #596C9C ', ' #503C8D ', ' #6042BE ', ' #906CFF ', ' #B08CC8 ', ' #A374AE ', ' #B4658E ', ' #CA62DF ', ' #A264D9 ', ' #90B36C ', ' #6C963D ', ' #6AB16A ', ' #75D285 ', ' #B3BB66 ', ' #C77272 ', ' #D75555 ', ' #A34646 ']
    return colors[index];
  }

  changeBreadCrumb() {
    this._comparisonService.isComparePage = false;
  }

  cancelComparison(template: TemplateRef<any>, classes: any) {

    this.modalRef = this.modalService.show(template, { class: classes });
  }

  openAnalyzeModal(template: TemplateRef<any>, classes: any) {
    this.comparePropertiesModel.Name = null;
    this.modalRef = this.modalService.show(template, { class: classes });
  }

  cancelSuccess() {
    //this.comparePropertiesModel.PropertyIds = [];
    this._comparisonService.isComparePage = false;
    this.modalRef.hide();
    this.Cancel();

  }

  scrollToBottom(element, offset) {
    $('html,body').animate({ scrollTop: ($(element).offset().top - 80) }, 500);
  }

  pdfDownload() {
    /*    $("body").removeClass("open-sidemenu");*/
    this.loaderService.display(true);
    setTimeout(() => {
      var divHeight = $('#capture').height();
      var divWidth = $('#capture').width() + 10;
      var ratio = divHeight / divWidth;
      var docDefinition = {};
      html2canvas(document.querySelector("#capture"), {
        scale: 2,
        height: divHeight,
        width: divWidth,
      }).then(function (canvas) {
        var data = canvas.toDataURL();
        var tenant = $('#tenant :selected').text();
        docDefinition = {
          pageMargins: [45, 20, 5, 20],
          pageSize: {
            width: 870,
            height: 'auto'
          },
          content: [{
            image: data,
            width: 800,
            height: (ratio * 870)
          }]
        };
        pdfMake.createPdf(docDefinition).download('PortfolioAnalysis.pdf');
      });
    }, 1000);
    setTimeout(() => {
      this.loaderService.display(false);
    }, 5000);
  }

  Cancel() {
    this.isShowAnalyze = false;
    this.analyzeId = 0;
    this.router.navigateByUrl("/market-snapshot?UserGuid=" + this.UserGuid + "&opentab=2");

  }

  Back() {
    this.isShowAnalyze = false;
    this.analyzeId = 0;
    this.isSaveDisabled = false;
    this.ngOnInit();
    this.resetSelectedRows();
  }

  onAcquisitionPriceChange(propertyId: number, acquisitionPrice: number) {
    if (acquisitionPrice == null || acquisitionPrice == undefined) {
      acquisitionPrice = 0;
    }

    let a = this.comparePropertyDetailModelList.find(x => x.PropertyId == propertyId);
    let updatedCapRate = 0;
    if (acquisitionPrice != 0) {
      updatedCapRate = parseFloat(((a.NOI / acquisitionPrice) * 100).toFixed(2));
    }

    a.CapRate = updatedCapRate;
    let totalCapRate = 0;
    let totalPrice = 0;
    this.comparePropertyDetailModelList.forEach(x => {
      if (x.CapRate != undefined && !Number.isNaN(x.CapRate)) {
        totalCapRate += x.CapRate;
      }
      if (x.AcquisitionPrice != undefined && !Number.isNaN(x.AcquisitionPrice)) {
        totalPrice += Number(x.AcquisitionPrice);
      }
    });
    this.comparePropertyDataTotalOrAvgModel.AcquisitionPriceTotalOrAvg = Number(totalPrice.toFixed(0));
    if (this.comparePropertyDataTotalOrAvgModel.AcquisitionPriceTotalOrAvg != 0) {
      this.comparePropertyDataTotalOrAvgModel.CapRateTotalOrAvg = Number((this.comparePropertyDataTotalOrAvgModel.NOITotalOrAvg / this.comparePropertyDataTotalOrAvgModel.AcquisitionPriceTotalOrAvg) * 100);
      this.comparePropertyDataTotalOrAvgModel.CapRateTotalOrAvg = Number(this.comparePropertyDataTotalOrAvgModel.CapRateTotalOrAvg.toFixed(2));
    }
    else {
      this.comparePropertyDataTotalOrAvgModel.CapRateTotalOrAvg = 0;
    }

    if (this.isPropertyAnalysis) {
      this.bindCapRateChartForPrpertyAnalysis();
    } else {
      this.bindCapRateChart();
    }

  }

  onCapRateChange(propertyId: number, capRate: number) {
    if (capRate == null || capRate == undefined) {
      capRate = 0;
    }

    if (capRate != null) {
      let a = this.comparePropertyDetailModelList.find(x => x.PropertyId == propertyId);

      let calculatedPrice = 0;

      if (capRate != 0) {
        calculatedPrice = ((a.NOI * 100) / capRate);
      }
      if (calculatedPrice != null) {
        a.AcquisitionPrice = parseFloat(calculatedPrice.toFixed(2));
      }
    }
    let totalCapRate = 0;
    let totalPrice = 0;
    this.comparePropertyDetailModelList.forEach(x => {
      if (x.CapRate != undefined && !Number.isNaN(x.CapRate)) {
        totalCapRate += x.CapRate;
      }
      if (x.AcquisitionPrice != undefined && !Number.isNaN(x.AcquisitionPrice)) {
        let price = parseFloat(x.AcquisitionPrice.toFixed(0));
        totalPrice += Number(price);
      }
    });
    this.comparePropertyDataTotalOrAvgModel.AcquisitionPriceTotalOrAvg = Number(totalPrice.toFixed(0));
    if (this.comparePropertyDataTotalOrAvgModel.AcquisitionPriceTotalOrAvg != 0) {
      this.comparePropertyDataTotalOrAvgModel.CapRateTotalOrAvg = (this.comparePropertyDataTotalOrAvgModel.NOITotalOrAvg / this.comparePropertyDataTotalOrAvgModel.AcquisitionPriceTotalOrAvg) * 100;
      this.comparePropertyDataTotalOrAvgModel.CapRateTotalOrAvg = Number(this.comparePropertyDataTotalOrAvgModel.CapRateTotalOrAvg.toFixed(2));
    }
    else {
      this.comparePropertyDataTotalOrAvgModel.CapRateTotalOrAvg = 0;
    }

    if (this.isPropertyAnalysis) {
      this.bindCapRateChartForPrpertyAnalysis();
    } else {
      this.bindCapRateChart();
    }
  }

  Analyze() {
    this.comparePropertiesModel.UserId = this.user.Id;
    this.comparePropertiesModel.PropertyIds = this.selectedRows.map(i => i.Id);
    this.comparePropertiesModel.IsPropertyAnalysis = false;
    this.comparePropertiesModel.IsOfferPortfolio = true;
    this.comparePropertiesModel.PropertyList = this.propertyList;
    this._comparisonService.comparePropertiesModelData = this.comparePropertiesModel;
    this.comparePropertiesModel.Exchange1031Id = 0;
    if (this.selectedRows.length > 1) {
      this.isShowAnalyze = true;
      this.LoadPortfolioAnalysisDetail();
      this.showNodata = false;
    }
    else {
      this._toastService.addToast({ title: 'Error Occurred', msg: 'Please select at least 2 properties', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })

      this.showNodata = true;
    }

  }

  OnClickOffMarket(propertyId: number, template: TemplateRef<any>, classes: any, properties: any) {
    this.selectedPendingProperty = {} as any;
    this.selectedPendindId = null;
    if (properties != null && propertyId != null && propertyId > 0) {
      let prop = [];
      prop.push(properties);
      let portfolioProperties = prop.map(o => {
        return {
          TenantName: o.PropertyName, State: o.StateName, City: o.CityName, Guid: o.Guid,
          RentNOI: o.NOI, Remaining_Term: o.RemainingTerm, DataentryPropertyStatusId: o.DataentryPropertyStatusId,
          PropertyAddress: o.Address, Address: o.PropertyAddress, LeaseStructure: o.LeaseType, OwnershipType: o.OwnershipType
        };
      });
      if (portfolioProperties != null) {
        this.pendingProperties = portfolioProperties;
        this.selectedPendindId = portfolioProperties[0].Guid;
        this.selectedPendingProperty = portfolioProperties[0];
        this.modalOffMarket = this.modalService.show(template, { class: classes });
      }
    }
  }

  proceedPricing() {
    if (this.selectedPendindId != null && this.selectedPendindId != '') {
      document.getElementById("openModalChangeToOffMarketButton").click();
      this.modalOffMarket.hide();
    }
    else {
      this.IsValid = false;
    }
  }

  openModalForQuickEdit1(template: TemplateRef<any>, classes: any) {
    this.modalRef = this.modalService.show(template, { class: classes });
  }

  onPropertyChanges() {
    this.selectedPendingProperty = {} as any;
    this.IsValid = true;
    if (this.selectedPendindId != null && this.selectedPendindId != '') {
      let selectedProp = this.pendingProperties.filter(f => f.Guid == this.selectedPendindId)[0];
      this.selectedPendingProperty = selectedProp;
    }
  }

  onclickEditProperty() {
    if (this.selectedPendindId != null && this.selectedPendindId != '') {
      this.modalOffMarket.hide();
      this.router.navigate(['/portfolio-principal-property/' + this.selectedPendindId], { queryParams: { UserGuid: this.UserGuid, IsmyPortfolio: this.IsmyPortfolio, prevroute: 'My Properties' } });
    }
    else {
      this.IsValid = false;
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(item => {
      item.unsubscribe();
    });
  }
}
